import React,{useState}     from 'react';
import * as S               from './styles';
import * as GV              from '../../../global/globalVariables';
import imageTop1            from '../../../assets/personaldiarytop1.png';
import imageTop2            from '../../../assets/personaldiarytop1.png';
import googleplay           from '../../../assets/googleplay.png';
import MenuGuide            from './menu';
import Others               from './others';
import Trailer              from './trailer';
import { i18n }             from '../../../translate/i18n';
import Contact              from '../../../components/Mail';

function HomePersonalDiary() {
    
    const [odd, setOdd] = useState(false);
    
    React.useEffect(() => {
        window.scrollTo(0, 0);
        setOdd( isOdd(randomNumberInRange(1, 9)) );
    }, []);
    
    function randomNumberInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function isOdd(num) {
        return Math.abs(num % 2) === 1;
    }
    
    function buttonDownload() {
        window.open('https://play.google.com/store/apps/details?id=com.kodasware.personaldiary', '_self');
    }

    return (
        <S.Container>
           
            { odd ? <S.TopImage><img src={imageTop1} alt=''></img></S.TopImage> : <S.TopImage><img src={imageTop2} alt=''></img></S.TopImage> }
            <S.HeaderApp>{i18n.t('header.app3')}</S.HeaderApp>
            <MenuGuide></MenuGuide>
                        
            <div id="about"></div>
            <S.TitleOption>{i18n.t('diary.menu1')}</S.TitleOption>
            <S.DescOption>{i18n.t('diary.menu1Desc1')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc2')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc3')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc4')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc5')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc6')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc7')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc8')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc9')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc10')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc11')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc12')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc13')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc14')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu1Desc15')}</S.DescOption>
            <S.DescOption><h3>{i18n.t('diary.menu1Desc16')}</h3></S.DescOption>
            <br></br><br></br><br></br>
            
            <S.DivisionLine></S.DivisionLine>
            <div id="features"></div>
            <S.TitleOption>{i18n.t('diary.menu2')}</S.TitleOption>
            <S.DescOption>{i18n.t('diary.menu2Desc')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu2Title1Desc')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu2Title2Desc')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu2Title3Desc')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu2Title4Desc')}</S.DescOption>
            <S.DescOption>{i18n.t('diary.menu2Title5Desc')}</S.DescOption>
            <br></br><br></br><br></br>

            <S.DivisionLine></S.DivisionLine>
            <div id="download"></div>
            <S.TitleOption>{i18n.t('diary.menu3')}</S.TitleOption>
            <S.DescOption>{i18n.t('diary.menu3Desc')}</S.DescOption>
            <br></br>
            <S.MidiaPlay onClick={buttonDownload}><img src={googleplay} alt=''></img></S.MidiaPlay>
            <S.DivisionLine></S.DivisionLine>
            <br></br><br></br><br></br>

            <div id="contact"></div>
            <S.TitleOption>{i18n.t('diary.menu4')}</S.TitleOption>
            <S.GuideDescTitle>{i18n.t('diary.menu4Title')}</S.GuideDescTitle>
            <S.GuideDesc>{i18n.t('diary.menu4Desc')}</S.GuideDesc>
            <Contact local={GV.CONTACT_LOCAL_APP_PERSONAL_DIARY}></Contact>
            <br></br><br></br><br></br>

            <S.DivisionLine></S.DivisionLine>
            <div id="others"></div>
            <S.TitleOption>{i18n.t('diary.menu5')}</S.TitleOption>

            <Others></Others>

            <Trailer></Trailer>
        </S.Container>
    )
}

export default HomePersonalDiary;